import React, { useState, useContext, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button,
  Typography } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContextProvider';
import { Link } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import { getTZDateTimeAsString } from '../utils/DateUtils';
import * as Constants from '../Constants';
import '../App.css';

const ScheduledEventList = () => {
  const [events, setEvents] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  
  useEffect(() => {
    const fetchEvents = async () => {
      let date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      const params = {
        _site: user._site._id,
        shownOn : {$gt: date}
      };
      rpc({
        method: "GetScheduledEvents",
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: onSuccess
      });
    }; 
    fetchEvents();
  }, [user]);
  
  const onSuccess = (events) => {
    setEvents(events);
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const onCreate= () => {
    navigate('/createScheduledEvent');
  };

  const getEventGroups = (event) => {
    return event._eventGroups.map((group) => group.displayName).join(', ');
  };

  const getPlayImmediately = (event) => {
    const playAttr = event._event.attributes.find((attr) => {
      return (attr.name === Constants.ATTR_PLAY_IMMEDIATELY);
    });
    return playAttr ? playAttr.value: 'false';
  };

  return (
    <div className="ScheduledEventList">
      <Typography variant="h6" gutterBottom>
        Scheduled Events
      </Typography>
      <TableContainer className="TableContainer" component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><b>Shown On</b></TableCell>
              <TableCell><b>Event</b></TableCell>
              <TableCell><b>Type</b></TableCell>
              <TableCell><b>Immediate</b></TableCell>
              <TableCell><b>Groups</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Link to={`/scheduledEvent/${event._id}`}>{getTZDateTimeAsString(event.shownOn, user._site.timezone)}</Link>
                </TableCell>
                <TableCell>{event._event.displayName}</TableCell>
                <TableCell>{Constants.EVENT_NAMES[event._event.type]}</TableCell>
                <TableCell>{getPlayImmediately(event)}</TableCell>
                <TableCell>{getEventGroups(event)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button className="Button" variant="contained" color="primary" onClick={onCreate}>
        Schedule Event
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default ScheduledEventList;
